// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JERvN","option":"styles_option__1Rxs2","active":"styles_active__22mnw"};